import { Directive, Input, OnInit } from "@angular/core";
import { BaseComponent, UserService } from "@mypxplat/xplat/core";

@Directive()
export abstract class ProductTileBaseComponent extends BaseComponent {
  constructor(userService: UserService) {
    super(userService);
  }
}
